<form class="university-form" [formGroup]="universityForm" (ngSubmit)="onSubmit()">
  <div class="form-row">
    <div class="form-group">
      <app-input
        id="universityName"
        formControlName="universityName"
        [label]="'profile.university.universityName' | transloco"
        [placeholder]="'profile.university.enterUniversityName' | transloco"
        [required]="true"
        [errorMessage]="
          universityForm.get('universityName')?.invalid && universityForm.get('universityName')?.touched ?
          (universityForm.get('universityName')?.errors?.['required'] ?
          ('validation.required.universityName' | transloco) :
          universityForm.get('universityName')?.errors?.['maxlength'] ?
          ('validation.databaseConstraint.universityName' | transloco: {max: VALIDATION.UNIVERSITY_NAME_MAX_LENGTH}) :
          '') : ''
        "></app-input>
    </div>
    <div class="form-group">
      <app-input
        id="fieldOfStudy"
        formControlName="fieldOfStudy"
        [label]="'profile.university.fieldOfStudy' | transloco"
        [placeholder]="'profile.university.enterFieldOfStudy' | transloco"
        [required]="true"
        [errorMessage]="
          universityForm.get('fieldOfStudy')?.invalid && universityForm.get('fieldOfStudy')?.touched ?
          (universityForm.get('fieldOfStudy')?.errors?.['required'] ?
          ('validation.required.fieldOfStudy' | transloco) :
          universityForm.get('fieldOfStudy')?.errors?.['maxlength'] ?
          ('validation.databaseConstraint.fieldOfStudy' | transloco: {max: VALIDATION.FIELD_OF_STUDY_MAX_LENGTH}) :
          '') : ''
        "></app-input>
    </div>
  </div>

  <div class="form-row">
    <div class="form-group">
      <app-select
        id="educationLevelID"
        formControlName="educationLevelID"
        [label]="'profile.university.educationLevel' | transloco"
        [placeholder]="'profile.university.selectEducationLevel' | transloco"
        [options]="educationLevelOptions"
        [required]="true"
        [errorMessage]="universityForm.get('educationLevelID')?.invalid && universityForm.get('educationLevelID')?.touched ? ('validation.required.educationLevel' | transloco) : ''">
      </app-select>
    </div>
  </div>

  <div class="form-row">
    <div class="form-group">
      <app-input
        id="city"
        formControlName="city"
        [label]="'profile.university.city' | transloco"
        [placeholder]="'profile.university.enterCity' | transloco"
        [required]="false"
        [errorMessage]="
          universityForm.get('city')?.invalid && universityForm.get('city')?.touched ?
          ('validation.maxLength.city' | transloco: {max: VALIDATION.CITY_MAX_LENGTH}) : ''
        "></app-input>
    </div>
    <div class="form-group">
      <app-input
        id="country"
        formControlName="country"
        [label]="'profile.university.country' | transloco"
        [placeholder]="'profile.university.enterCountry' | transloco"
        [required]="false"
        [errorMessage]="
          universityForm.get('country')?.invalid && universityForm.get('country')?.touched ?
          ('validation.maxLength.country' | transloco: {max: VALIDATION.COUNTRY_MAX_LENGTH}) : ''
        "></app-input>
    </div>
  </div>

  <div class="form-row">
    <div class="form-group">
      <app-input 
        id="startDate" 
        type="date" 
        formControlName="startDate" 
        [label]="'profile.university.startDate' | transloco" 
        [required]="true"
        [errorMessage]="universityForm.get('startDate')?.invalid && universityForm.get('startDate')?.touched ? ('validation.required.startDate' | transloco) : ''"></app-input>
    </div>
    <div class="form-group">
      <app-input
        id="endDate"
        type="date"
        formControlName="endDate"
        [label]="'profile.university.endDate' | transloco"
        [required]="!isCurrentlyStudying"
        [errorMessage]="universityForm.get('endDate')?.invalid && universityForm.get('endDate')?.touched && !universityForm.get('isCurrentlyStudying')?.value ? ('validation.required.endDate' | transloco) : (universityForm.errors?.['dateRange'] && universityForm.get('endDate')?.touched && !universityForm.get('isCurrentlyStudying')?.value ? ('profile.validation.endBeforeStart' | transloco) : '')"></app-input>
    </div>
  </div>

  <div class="form-row">
    <div class="form-group">
      <app-input-checkbox
        id="isCurrentlyStudying"
        formControlName="isCurrentlyStudying"
        [label]="'profile.university.currentlyStudying' | transloco"></app-input-checkbox>
    </div>
  </div>

  <!-- Certificate Upload Section -->
  <div class="form-row">
    <div class="form-group full-width">
      <label class="file-upload-label">{{ 'profile.university.certificate' | transloco }}</label>
      <div class="file-dropzone" [class.has-file]="attachment.fileName">
        <div class="file-dropzone__upload-area" *ngIf="!attachment.fileName">
          <div class="file-dropzone__icon">
            <i class="fas fa-file-upload"></i>
          </div>
          <div class="file-dropzone__text">
            <p>{{ 'profile.university.dragDropDocuments' | transloco }}</p>
            <span>{{ 'profile.resume.or' | transloco }}</span>
          </div>
          <app-button type="button" size="md" variant="outline" color="secondary" (click)="fileInput.click()">
            {{ 'profile.resume.browse' | transloco }}
          </app-button>
          <p class="file-dropzone__info">{{ 'profile.resume.supportedFormats' | transloco }}</p>
          <input type="file" hidden #fileInput (change)="onFileChange($event)" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" />
        </div>

        <div class="file-dropzone__file-info" [class.hidden]="!attachment.fileName">
          <div class="file-dropzone__file-icon">
            <i class="fas fa-file-pdf"></i>
          </div>
          <div class="file-dropzone__file-details">
            <div class="file-dropzone__file-name">{{ attachment.fileName }}</div>
            <div class="file-dropzone__file-size">{{ attachment.fileSize }}</div>
          </div>
          <app-button type="button" variant="outline" color="secondary" (click)="removeFile()">
            <i class="fas fa-times"></i>
          </app-button>
        </div>

        <!-- Loading indicator -->
        <div class="file-dropzone__loading" *ngIf="isUploading">
          <div class="spinner"></div>
          <p>{{ 'profile.university.uploading' | transloco }}</p>
        </div>
        
        <!-- Error message -->
        <div class="file-dropzone__error" *ngIf="fileError">
          <div class="file-dropzone__error-icon">
            <i class="fas fa-exclamation-circle"></i>
          </div>
          <p class="file-dropzone__error-message">{{ fileError }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="form-actions">
    <app-button type="button" variant="outline" color="secondary" (click)="cancel.emit()">
      {{ 'button.cancel' | transloco }}
    </app-button>
    <app-button type="submit" variant="filled" [disabled]="universityForm.invalid || isUploading">
      {{ 'button.save' | transloco }}
    </app-button>
  </div>
</form>
